module.exports = __webpack_public_path__ + "static/media/kv_mobile.904ecd50.png";